export const EN_US = 'en-US'
export const DEFAULT_LOCALE = EN_US
